import React from 'react';
import { motion } from 'framer-motion';
export function PromptDemo() {
  return <section className="py-32 bg-black-charcoal relative border-y border-white/5" data-id="element-264">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-265">
        <div className="text-center mb-16" data-id="element-266">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gold text-sm font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-267">
            See what you're getting
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl text-offwhite tracking-tight leading-[1.05]" data-id="element-268">
            A real, organized{' '}
            <span className="text-gold" data-id="element-269">Notion dashboard.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-muted max-w-2xl mx-auto mt-6" data-id="element-270">
            Every prompt is engineered with role-playing, frameworks and tone —
            beautifully organized by category. Duplicate it to your workspace in
            one click and start using the prompts immediately.
          </motion.p>
        </div>

        {/* Mac Window Mockup with Real Screenshot */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative max-w-5xl mx-auto" data-id="element-271">
          {/* Gold ambient glow behind window */}
          <div className="absolute inset-0 bg-gold-radial opacity-30 blur-3xl scale-110 pointer-events-none" data-id="element-272" />

          <div className="relative bg-[#0D0D0D] border border-white/10 rounded-2xl overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.6)]" data-id="element-273">
            {/* Mac window top bar */}
            <div className="bg-[#1A1A1A] border-b border-white/10 px-4 py-3 flex items-center gap-3" data-id="element-274">
              <div className="flex gap-1.5" data-id="element-275">
                <div className="w-3 h-3 rounded-full bg-red-500/80" data-id="element-276" />
                <div className="w-3 h-3 rounded-full bg-yellow-500/80" data-id="element-277" />
                <div className="w-3 h-3 rounded-full bg-green-500/80" data-id="element-278" />
              </div>
              <div className="flex-1 flex justify-center" data-id="element-279">
                <div className="bg-black/50 border border-white/5 rounded-md px-4 py-1 text-[11px] text-muted font-mono" data-id="element-280">
                  notion.so/500-ai-prompts
                </div>
              </div>
              <div className="w-12" data-id="element-281" />
            </div>

            {/* The real screenshot */}
            <img src="https://cdn.magicpatterns.com/uploads/en2o3g6J19HMdxPEgTewZW/Screenshot_2026-05-26_at_6.39.41_PM.png" alt="Example of how the 500 AI Prompts are delivered in a Notion dashboard" className="w-full block" data-id="element-282" />
          </div>

          <p className="text-xs text-muted mt-6 italic text-center" data-id="element-283">
            Just one of 10+ categories. All 500 prompts are organized the same
            way.
          </p>
        </motion.div>
      </div>
    </section>;
}